"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormRadioInput = _interopRequireDefault(require("./FormRadioInput"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _PropUtils = require("../../util/PropUtils");

var _underscore = require("underscore");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @callback FormRadioGroup~onValueChange
 * @param {object} selectedId
 *     Newly selected id value from original items prop
 */

/**
 * @typedef FormRadioGroup~RadioGroupItem
 * @property {boolean} [disabled]
 *     Disables the input.
 * @property {string} [hint]
 *     Text to display in help hint next to the item's name.
 * @param {object} [helpTarget]
 *     An optional icon or image to replace standard help hint icon.
 * @property {boolean} [hidden]
 *     Hides the input.
 * @property {string} [value]
 *     The item's identifier.
 * @property {node} [hint]
 *     Help hint text to display alongside label.
 * @property {string} [label]
 *     The item's display text.
 */

/**
 * @class FormRadioGroup
 * @desc FormRadioGroup renders the any object (key/display) into a group of radio buttons
 *
 * @param {boolean} [autoFocus=false]
 *     Whether or not to auto-focus the element.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {string} [data-id="radio-btn"]
 *     To define the base "data-id" value for top-level HTML container.
 * @property {node} [description]
 *     Description to display below the label.
 * @param {boolean} [disabled=false]
 *     If radio buttons are disabled.
 * @param {string} groupName
 *     Name of the radio group.
 * @param {FormRadioGroup~RadioGroupItem[]} items
 *     Array of RadioGroupItem objects to render.
 * @property {node} [label]
 *     String or JSX element to display the label for the radio button.
 * @param {FormRadioGroup~onValueChange} [onValueChange]
 *     Callback to be triggered when the selection is changed.
 * @param {*} [selected]
 *     The selected "id" from the items object above. If none is passed-in, all radio buttons are left unchecked
 * @param {boolean} [stacked=true]
 *     When true, radios inputs are stacked vertically. When false radio inputs appear on same line
 *     and wrap when out of space.
 * @param {FormRadioGroup~radioRenderer} renderRadio
 *     Renders a single radio button.
 *
 *
 * @example
 *
 *     _changeRadioSelection: function (value) {
 *         this.setState({
 *             radioChoice: value
 *         });
 *     }
 *
 *     var apsConditionTypes = [
 *         {
 *             id: PolicyConditionsConstants.ConditionType.APS_APPLICATIONS,
 *             name: "Applications"
 *         },
 *         {
 *             id: PolicyConditionsConstants.ConditionType.APS_CUSTOMERS,
 *             name: "Customers",
 *             hidden: !this.props.apsCustomersEnabled,
 *             helpHintText: "Sample help hint text"
 *         },
 *         {
 *             id: PolicyConditionsConstants.ConditionType.APS_WHATEVER,
 *             name: "Customers",
 *             disabled: true
 *         }
 *     ];
 *
 *     <FormRadioGroup
 *         data-id="my-radio-group"
 *         groupName="aps_condition_type"
 *         selected={PolicyConditionsConstants.ConditionType.APS_APPLICATIONS}
 *         onValueChange={this._handleChange}
 *         disabled={this._radioGroupDisabled}
 *         items={apsConditionTypes} />
 */

/**
 *  @typedef {function} FormRadioGroup~RadioRenderer
 *  @desc Function for overriding default rendering
 *  @param {FormRadioInput} props
 *      Object of props that can be passed to the component
 *  @param {object} [DefaultComponent=FormRadioInput]
 *      The component that encompasses the default rendering. Accepts props from the props parameter
 */
var FormRadioGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormRadioGroup, _React$Component);

  var _super = _createSuper(FormRadioGroup);

  function FormRadioGroup() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FormRadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleChange", function (value) {
      _this.props.onValueChange(value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getRadioButtons", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          dataId = _this$props["data-id"],
          disabled = _this$props.disabled,
          groupName = _this$props.groupName,
          items = _this$props.items,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? (0, _PropUtils.translateItemsToOptions)(items) : _this$props$options,
          renderRadio = _this$props.renderRadio,
          selected = _this$props.selected,
          stacked = _this$props.stacked,
          autoFocus = _this$props.autoFocus;
      return (0, _map.default)(options).call(options, function (_ref) {
        var helpHintText = _ref.helpHintText,
            _ref$hint = _ref.hint,
            hint = _ref$hint === void 0 ? helpHintText : _ref$hint,
            helpTarget = _ref.helpTarget,
            hidden = _ref.hidden,
            value = _ref.value,
            label = _ref.label,
            option = (0, _objectWithoutProperties2.default)(_ref, ["helpHintText", "hint", "helpTarget", "hidden", "value", "label"]);
        var radioDisabled = disabled || option.disabled;
        var radioClassName = (0, _classnames.default)("input-radio", "group", className, {
          stacked: stacked,
          disabled: radioDisabled,
          hidden: hidden
        });
        return renderRadio({
          className: radioClassName,
          key: value,
          label: label,
          hint: hint,
          "data-id": dataId,
          name: groupName,
          value: value,
          checked: String(value) === String(selected),
          onValueChange: _this._handleChange,
          disabled: radioDisabled,
          helpTarget: helpTarget,
          autoFocus: autoFocus && String(value) === String(selected)
        }, _FormRadioInput.default);
      });
    });
    return _this;
  }

  (0, _createClass2.default)(FormRadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          labelText = _this$props2.labelText,
          _this$props2$label = _this$props2.label,
          label = _this$props2$label === void 0 ? labelText : _this$props2$label;
      return label ? /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        "data-id": this.props["data-id"],
        description: this.props.description,
        disabled: this.props.disabled,
        value: label,
        hint: this.props.labelHelpText,
        className: "list"
      }, this._getRadioButtons()) : /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: "list"
      }, this._getRadioButtons());
    }
  }]);
  return FormRadioGroup;
}(_react.default.Component);

(0, _defineProperty2.default)(FormRadioGroup, "propTypes", {
  autoFocus: _propTypes.default.bool,
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  description: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  groupName: _propTypes.default.string.isRequired,
  items: _propTypes.default.array,
  label: _propTypes.default.node,
  labelText: _propTypes.default.node,
  labelHelpText: _propTypes.default.node,
  onValueChange: _propTypes.default.func,
  options: _propTypes.default.array,
  renderRadio: _propTypes.default.func,
  selected: _propTypes.default.any,
  stacked: _propTypes.default.bool
});
(0, _defineProperty2.default)(FormRadioGroup, "defaultProps", {
  autoFocus: false,
  "data-id": "radio-btn",
  disabled: false,
  onValueChange: _underscore.noop,
  renderRadio: _PropUtils.defaultRender,
  stacked: true
});
var _default = FormRadioGroup;
exports.default = _default;
module.exports = exports["default"];